import { AssignmentQuiz, DashboardStream, SubjectNotice } from 'components/common/dashboard';
import BreadCrumb from 'components/shared/BreadCrumb';
import { useGetCalendarApi, useGetCommonApi, useGetQuery, useGetTeacherQuery } from 'hooks';

import { StudySentence } from 'components/common/dashboard/StudySentence';
import { SubjectNoticePopup } from 'components/popup';
import { DashBoardNews } from 'components/shared/dashboard/DashBoardNews';
import { useGetRequiredApi } from 'hooks/useGetRequiredApi';
import { useRecoilState, useRecoilValue, useResetRecoilState } from 'recoil';
import { subjectNoticePopupState } from 'recoil/dashboard/subjectNoticePopupState';
import { StudentProgress } from '.';
import { Link, useNavigate } from 'react-router-dom';
import { Form, Tab, Tabs } from 'react-bootstrap';
import useSsoRouting from 'hooks/common/useSsoRouting';
import { getLectureQuery } from 'api/getLectureQuery';
import { getDataQuery } from 'api';
import { useEffect, useState } from 'react';
import { ScheduleCalendar } from 'components/calendar';
import { useCalendarIndex } from 'recoil/caleandar/calendarIndex';
import { CardHeader } from 'components/common';
import { subjectOptionDataState } from 'recoil/subject/subjectOptionDataState';
import { sisCourseState } from 'recoil/subject/sisCourseState';
import { teacherInfoState } from 'recoil/subject/teacherInfoState';
import { loginUser } from 'recoil/loginUser';

export function MainTeacher() {
  const navigate = useNavigate();
  const [subjectPopupState, setSubjectPopupState] = useRecoilState(subjectNoticePopupState);
  const [key, setKey] = useState("subjectNotice");
  const [calendarIndex, setCalendarIndex] = useRecoilState(useCalendarIndex);
  const [subjectState, setSubjectState] = useRecoilState(subjectOptionDataState);
  const [sisCourseIdState, setSisCourseIdState] = useRecoilState(sisCourseState);
  const [selectTeacherInfo, setSelectTeacherInfo] = useRecoilState(teacherInfoState)
  const user = useRecoilValue(loginUser);
  const resetSubjectState = useResetRecoilState(subjectOptionDataState);
  const resetTeacherInfo = useResetRecoilState(teacherInfoState);
  const resetSisCourse = useResetRecoilState(sisCourseState);
  const [filteredAdvisorList, setFilteredAdvisorList] = useState([]);
  const [isAdvisorLoading, setIsAdvisorLoading] = useState(false);
  const [activeKey, setActiveKey] = useState('academicSchedule'); // 기본 활성 탭 설정

  useEffect(() => {
    resetSubjectState();
    resetTeacherInfo();
    resetSisCourse();
  }, []);

  const handleTabSelect = (k) => {
    setActiveKey(k); // 탭 변경 시 상태 업데이트
  };

  const {
    // 학기정보
    semesterData,
    semesterIsLoading,
    semesterIsError,
    semestersData,
    semestersIsLoading,
    semestersIsError,
  } = useGetCommonApi();
  
  const {
    // 교수자 / 관리자 - [학습현황] 등록되어 있는 게시중인 과목 리스트 정보 API
    // subject 상위 select-box list
    teacherSelectBoxQueryData,
    teacherSelectBoxQueryIsLoading,
    teacherSelectBoxQueryIsError,

    // subject 상위 select-box list
    teacherTermSelectBoxQueryData,
    teacherTermSelectBoxQueryIsLoading,
    teacherTermSelectBoxQueryIsError,

    // 교수자 / 관리자 - 해당 학과의 담당 교수, 지도 교수 조회
    teacherInfoSelectBoxQueryData,
  } = useGetRequiredApi(subjectState.courseId, subjectState.openYy, subjectState.openTmGbn);

  const {
    // 학사일정
    calendarAcademicData,
    calendarAcademicIsLoading,
    calendarAcademicIsError,
    // 유저일정
    calendarUserData,
    calendarUserIsLoading,
    calendarUserIsError,
  } = useGetCalendarApi();

  const { assignmentData, assignmentIsLoading } = useGetTeacherQuery();
  const { teacherStudentProgressData } = useGetTeacherQuery();

  const {
    // 활동 스트림
    activitySteamData,
    activitySteamIsLoading,
    activitySteamIsError,
  } = useGetQuery();

  useEffect(() => {
    if (teacherInfoSelectBoxQueryData?.[0]?.mainTeachers?.length > 0) {
      const firstCourse = teacherInfoSelectBoxQueryData[0].mainTeachers[0].courseTeacherInfo[0].sisCourseId;
      const parts = firstCourse.split('-');

      setSisCourseIdState({
        openYy: parts[0],
        openTmGbn: parts[1],
        scCd: parts[2],
        openDeptCd: parts[4]
      });
    }
  }, [teacherInfoSelectBoxQueryData]);
  
  
  // 대표교수와 지도교수를 분리
  const mainProfessors = teacherInfoSelectBoxQueryData?.flatMap(item => item.mainTeachers) || [];
  const advisorProfessors = teacherInfoSelectBoxQueryData?.flatMap(item => item.advisorTeachers) || [];

  // 내가 대표교수인지 & 지도교수인지 확인
  const myAdvisorCourses = advisorProfessors.filter(item => item.teacherNumber === user.loginId);
  const isAdvisorProfessor = myAdvisorCourses.length > 0;
  const isMainProfessor = mainProfessors.some(item => item.teacherNumber === user.loginId);

  const filteredMainProfessors = (() => {
    if (!isAdvisorProfessor && isMainProfessor) {
      return mainProfessors;
    } else {
      return mainProfessors.filter(mainProf =>
        mainProf.teacherNumber === user.loginId ||
        myAdvisorCourses.some(advisorCourse =>
          mainProf.courseTeacherInfo.some(mainCourse =>
            advisorCourse.courseTeacherInfo.some(advisorMainCourse =>
              advisorMainCourse.sisCourseId === mainCourse.sisCourseId
            )
          )
        )
      );
    }
  })();
  console.log("teacherTermSelectBoxQueryData: ", teacherTermSelectBoxQueryData);
  const filteredCourses = teacherTermSelectBoxQueryData?.filter(course => {
    const courseYear = course.sis_course_id.split('-')[0]; // 맨 앞 4자리 (연도) 추출
  
    if (courseYear === "2024") {
      return true; // 2024년이면 전체 데이터 반환
    }
  
    // 2024년이 아닐 경우, filteredAdvisorList를 타도록 필터링
    return filteredAdvisorList.some(advisor =>
      advisor.courseTeacherInfo.some(advisorCourse => advisorCourse.sisCourseId === course.sis_course_id)
    );
  });
  

  useEffect(() => {
    if (teacherTermSelectBoxQueryData?.length > 0) {
      const firstItem = teacherTermSelectBoxQueryData[0].sis_course_id;
      const parts = firstItem.split('-');
  
      const semesterYear = `${parts[0]}-${parts[1]}`;
  
      const sisCourseData = {
        openYy: parts[0] || null,
        openTmGbn: parts[1] || null,
        scCd: parts[2] || null,
        openDeptCd: semesterYear === '2024-10' ? parts[3] || null : parts.at(-1) || null, 
      };
      
      setSisCourseIdState(sisCourseData);
    }
  }, [teacherTermSelectBoxQueryData]);

  // 학기 이벤트 핸들러
  const handleSelectTermBox = (e) => {
    setSelectTeacherInfo([]);
    if (!e.target.value) return;
    const selected = semestersData?.data?.find(item => item.id === Number(e.target.value));
    const sisTermId = selected?.sis_term_id || '';
    const openYy = sisTermId.length >= 4 ? parseInt(sisTermId.substring(0, 4)) : null;
    const openTmGbn = sisTermId.length > 4 ? parseInt(sisTermId.substring(4)) : null;
    setSubjectState({ ...subjectState, termId: e.target.value, termName: selected?.name || '', openYy, openTmGbn })
  }

  // 대표교수 선택 이벤트
  const handleSelectMainTeacherBox = async (e) => {
    const selectedTeacherNumber = e.target.value;
    const selectedName = e.target.options[e.target.selectedIndex].text.split('-').map(str => str.trim())[0];

    setSelectTeacherInfo(prev => ({
      ...prev,
      managerNumber: selectedTeacherNumber || null,
      managerName: selectedName || null,
      advisorNumber: null,
      advisorName: null,
    }));

    if (!selectedTeacherNumber) {
      setFilteredAdvisorList([]);
      setIsAdvisorLoading(false);
      return;
    }

    const selectedProfessor = mainProfessors.find(item =>
      item.teacherNumber === selectedTeacherNumber &&
      item.courseTeacherInfo.some(course => course.courseName === selectedName)
    );

    if (!selectedProfessor) return;

    const selectedSisCourseId = selectedProfessor.courseTeacherInfo[0].sisCourseId;
    const matchedCourse = teacherTermSelectBoxQueryData?.find(
      c => c.sis_course_id === selectedSisCourseId
    );

    if (!matchedCourse) return;

    const courseId = matchedCourse.course_id;
    const parts = selectedSisCourseId.split('-');
    const openYy = parts[0];
    const openTmGbn = parts[1];

    setIsAdvisorLoading(true);
    const res = await getDataQuery(
      `/teach/info/advisors?courseId=${courseId}&openYy=${openYy}&openTmGbn=${openTmGbn}&sisCourseId=${selectedSisCourseId}`
    );

    let filteredAdvisors = res?.data || [];

    // 내가 지도교수만 해당될 경우 → 나만 반환
    if (isAdvisorProfessor && !isMainProfessor) {
      filteredAdvisors = filteredAdvisors.filter(advisor => advisor.teacherNumber === user.loginId);
    }

    setFilteredAdvisorList(filteredAdvisors);
    setIsAdvisorLoading(false);
  };

  

  // 지도교수 선택 이벤트
  const handleSelectAdvisorBox = (e) => {
    const selectedTeacherNumber = e.target.value;
    const selectedAdvisor = filteredAdvisorList.find(item => item.teacherNumber === selectedTeacherNumber);

    if (!selectedAdvisor) return;

    setSelectTeacherInfo(prev => ({
      ...prev,
      advisorNumber: selectedAdvisor.teacherNumber,
      advisorName: selectedAdvisor.teacherName,
    }));
  };


  const { ssoRouting } = useSsoRouting();
  // 온라인 강의실
  const handleGoingLecture = async (url) => {
    ssoRouting(url);
    const { data: getCanvasUrl } = await getLectureQuery('');
    
    if (getCanvasUrl?.errorCode) return;
    window.location.replace(getCanvasUrl);
  };

  const handleAttendancesAndGrades = (type, course) => {
    setSubjectState(prev => ({ ...prev, courseId: course.course_id, subAccountName: course.sub_account_name }));
    if (type === 'attendance') {
      navigate('/attendance')
    } else if (type === 'grade') {
      navigate('/grade')
    }
  };

  const handleSelect = (k) => {
    setKey(k);
  };

  const switchCalendar = () => {
    setCalendarIndex(!calendarIndex);
  };

  return (
    <>
      <main id='main' className='main'>
        <div className='d-flex justify-content-start align-items-center'>
          <BreadCrumb home={'/'} sublink={'/'} title={'My Class'} subTitle={'홈'} />
          <div className="d-flex justify-content-start align-items-center ml-20"
            style={{ gap: "2rem" }}>
              <div className='d-flex align-items-center'>
                <Form.Select
                  id="subjectWeek"
                  name="subjectWeek"
                  onChange={handleSelectTermBox}
                  value={subjectState.termId || ''}
                >
                  <option value="">학기 선택</option>
                  {semestersData?.data?.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Form.Select>
              </div>
            {/* 대표교수 선택 - 2025년도 이상이고 teacherTermSelectBoxQueryData 로드 완료 시 표시 */}
            {parseInt(subjectState.openYy) >= 2025 && teacherTermSelectBoxQueryData?.length > 0 && (
            <div className="d-flex align-items-center">
              <Form.Select
                aria-label="대표교수 선택"
                id="mainProfessorSelect"
                name="mainProfessor"
                onChange={handleSelectMainTeacherBox}
                style={{ width: "200px" }}
              >
                <option value="">대표교수 선택</option>
                {filteredMainProfessors.map(item => (
                  <option key={item.teacherNumber} value={item.teacherNumber}>
                    {item.courseTeacherInfo?.map((course) => course.courseName)} - {item.teacherName}
                  </option>
                ))}
              </Form.Select>
            </div>
            )}
            {/* 지도교수 선택 - 2025년도 이상이고 지도교수 로드 완료 시 표시 */}
            {parseInt(subjectState.openYy) >= 2025 && selectTeacherInfo.managerNumber && !isAdvisorLoading && (
            <div className="d-flex align-items-center">
              <Form.Select
                aria-label="지도교수 선택"
                id="advisorProfessorSelect"
                name="advisorProfessor"
                onChange={handleSelectAdvisorBox}
                style={{ width: "200px" }}
                value={selectTeacherInfo.advisorNumber || ""}
              >
                <option value="">지도교수 선택</option>
                {filteredAdvisorList.map(item => (
                  <option key={item.teacherNumber} value={item.teacherNumber}>
                    {item.teacherName} - {item.courseTeacherInfo?.map((course) => {
                      const parts = course.sisCourseId.split('-'); // '-' 기준으로 분할
                      return parts[3]; // 4번째 값(분반)만 출력
                    }).join(', ')}
                  </option>
                ))}
              </Form.Select>
            </div>
            )}
          </div>
        </div>
        <section className='section dashboard'>
          <div className='row'>
            <div className='col-lg-8'>
              <div className='row'>
                <div className="cards-container">
                  {(parseInt(subjectState.openYy) < 2025 || selectTeacherInfo.advisorNumber) && filteredCourses?.map((course, idx) => (
                    <div key={course.course_id} className="horizontal-course-card">
                      <div className={`d-flex justify-content-between card-header ch-bg${idx + 1}`}>
                        <h3 className="card-title">{course.course_name}</h3>
                      </div>
                      <div className="card-tab">
                        <div className="card-tab-content mr-5" onClick={() => handleGoingLecture(`/courses/${course.course_id}`)}>
                          <img
                            src="/assets/img/icon/home_icon.png"
                            alt="Announcements Icon"
                            className="card-icon-img"
                          />
                          <div>홈</div>
                        </div>
                        <div className="card-tab-content mr-5" onClick={() => handleGoingLecture(`/courses/${course.course_id}/announcements`)}>
                          <img
                            src="/assets/img/icon/announcements_icon.png"
                            alt="Announcements Icon"
                            className="card-icon-img"
                          />
                          <div>공지사항</div>
                        </div>
                        <div className="card-tab-content mr-5" onClick={() => handleGoingLecture(`/courses/${course.course_id}/assignments`)}>
                          <img
                            src="/assets/img/icon/assignments_icon.png"
                            alt="Assignments Icon"
                            className="card-icon-img"
                          />
                          <div>과제</div>
                        </div>
                        <div className="card-tab-content mr-5" onClick={() => handleAttendancesAndGrades("attendance", course)}>
                          <img
                            src="/assets/img/icon/attendances_icon.png"
                            alt="Grades Icon"
                            className="card-icon-img"
                          />
                          <div>출석</div>
                        </div>
                        <div className="card-tab-content mr-5" onClick={() => handleAttendancesAndGrades("grade", course)}>
                          <img
                            src="/assets/img/icon/grades_icon.png"
                            alt="Grades Icon"
                            className="card-icon-img"
                          />
                          <div>성적</div>
                        </div>
                        <div className="card-tab-content mr-5"onClick={() => handleGoingLecture(`/courses/${course.course_id}/users`)}>
                          <img
                            src="/assets/img/icon/user_group_icon.png"
                            alt="Announcements Icon"
                            className="card-icon-img"
                          />
                          <div>사용자 및 그룹</div>
                        </div>
                        <div className="card-tab-content mr-5" onClick={() => handleGoingLecture(`/courses/${course.course_id}/files`)}>
                          <img
                            src="/assets/img/icon/files_icon.png"
                            alt="Files Icon"
                            className="card-icon-img"
                          />
                          <div>파일</div>
                        </div>
                        <div className="card-tab-content mr-5" onClick={() => handleGoingLecture(`/courses/${course.course_id}/assignments/syllabus`)}>
                          <img
                            src="/assets/img/icon/lecture_plan_icon.png"
                            alt="Announcements Icon"
                            className="card-icon-img"
                          />
                          <div>강의계획서</div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className='col-lg-4'>
              <div className="card p-20">
                <Tabs
                  id="schedule-tabs"
                  activeKey={activeKey}
                  onSelect={handleTabSelect}
                  className="custom-tabs"
                >
                  {/* 학사일정 탭 */}
                  <Tab eventKey="academicSchedule" title="개인일정">
                    <ScheduleCalendar
                      data={
                        calendarIndex && calendarAcademicData
                          ? calendarAcademicData
                          : []
                      }
                    />
                  </Tab>
                  {/* 개인일정 탭 */}
                  <Tab eventKey="personalSchedule" title="학사일정">
                    <ScheduleCalendar
                      data={
                        !calendarIndex && calendarUserData
                          ? calendarUserData
                          : []
                      }
                    />
                  </Tab>
                </Tabs>
              </div>
              <Tabs
                id="controlled-tab-example"
                activeKey={key}
                onSelect={handleSelect}
                className="custom-tabs"
              >
                <Tab eventKey="subjectNotice" title="과목 공지사항">
                  <SubjectNotice
                    data={teacherSelectBoxQueryData?.map((el) => ({
                      ...el,
                      name: el.course_name,
                      course_id: el.course_id,
                    }))}
                    cardTitle={semesterData?.data?.name}
                  />
                </Tab>
                <Tab eventKey="ctlNotice" title="공지사항">
                  <DashBoardNews />
                </Tab>
              </Tabs>
            </div>
          </div>
        </section>
      </main>
      {subjectPopupState.visible && <SubjectNoticePopup />}
    </>
  );
}
